module.exports = {
  "country": "AL",
  "artist": "Ronela Hajati",
  "song": "Sekret",
  "year": "2022",
  "place": "NQ",
  "spotify": "6IFdGCKcsAGq0s02WGhC9x"
};